var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroBlob3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 252,
    height: 230.341,
    viewBox: "0 0 252 230.341",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Watercolor blob",
    opacity: 0.75,
    filter: "url(#filter0_f_0_49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M130.345 20C169.448 10 204.207 40 217.241 80C230.276 120 225.931 165 195.517 190C165.103 215 112.966 220 78.2069 200C43.4483 180 26.069 140 34.7586 100C43.4483 60 91.2414 30 130.345 20Z",
    fill: "url(#paint0_linear_0_49)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_49",
    x: -18,
    y: -18,
    width: 288,
    height: 261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "effect1_foregroundBlur_0_49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_49",
    x1: 32.5442,
    y1: 18.0619,
    x2: 171.302,
    y2: 154.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EBBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBlob3);
export default __webpack_public_path__ + "static/media/hero-blob-3.273ec459bbaa93768f233775ece0e561.svg";
export { ForwardRef as ReactComponent };